import React from "react";

const Loader = () => {
    return (
        <div className="flex justify-center items-center">
            <div className="flex space-x-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-0"></div>
                <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce delay-200"></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-400"></div>
            </div>
        </div>
    );
};

export default Loader;